import classNames from 'classnames';
import { useController, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useUserSelfDetails } from '@steelbuy/data-access';
import { Literal, UserRole } from '@steelbuy/ts-shared';
import { ButtonTertiaryOnLightM, IconIdentifier } from '@steelbuy/ui-primitive';
import { materialsSelection } from './dashboardListingsUtil';
import { RoutePath } from '../../router/Routes';

export const DashboardMaterialSelection = () => {
    const { t } = useTranslation(['translation', 'domainModel']);
    const { control, setValue } = useFormContext();

    const {
        field: { onChange },
    } = useController({
        name: 'materialType',
        control,
        rules: { required: true },
    });
    const formValues = useWatch({ control });
    const selectedId = formValues.definition ?? formValues.materialType;
    const navigate = useNavigate();
    const { data: userData } = useUserSelfDetails();
    const hasBuyerRole = userData?.roles.includes(UserRole.BUYER) ?? false;

    return (
        <div className="dashboard-material-selection">
            <div className="dashboard-material-selection-heading">
                {t('application.dashboardListings.materialSelectionHeading')}
                {hasBuyerRole && (
                    <ButtonTertiaryOnLightM
                        label={t('application.dashboard.searchListings')}
                        onClick={() => navigate(RoutePath.SEARCH_LISTINGS)}
                        icon={IconIdentifier.SEARCH}
                    />
                )}
            </div>
            <div className="dashboard-material-selection-options">
                {materialsSelection.map(({ image, materialType, definition, shortName }) => {
                    const shortLabel = shortName ? t(shortName as Literal) : undefined;
                    const label = t(
                        `domainModel:material.${definition ? 'definition' : 'materialType'}.value.${
                            definition ?? materialType
                        }` as Literal
                    );
                    return (
                        <div
                            key={materialType + (definition ?? '')}
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                                onChange(materialType);
                                setValue('definition', definition ?? undefined, {
                                    shouldDirty: true,
                                    shouldTouch: true,
                                });
                            }}
                            className={classNames('dashboard-material-selection-options__option', {
                                'dashboard-material-selection-options__option--selected':
                                    selectedId === (definition ?? materialType),
                            })}
                            onKeyDown={(e) => e.key === 'Enter' && onChange(materialType)}
                        >
                            <img src={`assets/lib-ui-primitive/images/${image}`} alt={label} />
                            <div>{shortLabel ?? label}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
